export default {
  chatStream (data) { // 流式用fetch
    return fetch('https://ai.hydts.cn/ai/chat-stream', {
      method: 'POST',
      timeout: 15000,
      body: JSON.stringify(data)
    })
  }
}
